import { IQuoteServiceVariableState } from '@/store/quote-service-variable';
import { IQuoteServiceVariableMutations } from './mutations.types';
import { IQuoteServiceVariableData } from '@/models';

export const mutations: IQuoteServiceVariableMutations = {
  SET_QUOTE_SERVICE_VARIABLES(
    state: IQuoteServiceVariableState,
    payload: IQuoteServiceVariableData[]
  ): void {
    state.quoteServiceVariables = payload;
  },

  ADD_QUOTE_SERVICE_VARIABLE(
    state: IQuoteServiceVariableState,
    payload: IQuoteServiceVariableData
  ): void {
    state.quoteServiceVariables.push(payload);
  },

  UPDATE_QUOTE_SERVICE_VARIABLE(
    state: IQuoteServiceVariableState,
    payload: IQuoteServiceVariableData
  ): void {
    const index = state.quoteServiceVariables.findIndex(
      (quoteservicevariable: IQuoteServiceVariableData) =>
        quoteservicevariable.id === payload.id
    );

    state.quoteServiceVariables.splice(index, 1, payload);
  },

  REMOVE_QUOTE_SERVICE_VARIABLE(
    state: IQuoteServiceVariableState,
    payload: number
  ): void {
    const index = state.quoteServiceVariables.findIndex(
      (quoteservicevariable: IQuoteServiceVariableData) =>
        quoteservicevariable.id === payload
    );

    state.quoteServiceVariables.splice(index, 1);
  }
};
